import { checkboxAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const checkboxSlotRecipe = defineSlotRecipe({
  className: 'checkbox',
  slots: checkboxAnatomy.keys(),
  base: {
    root: {
      display: 'inline-flex',
      alignItems: 'flex-start',
      gap: '8',
      width: 'fit-content',
      cursor: 'pointer',
      _disabled: {
        cursor: 'not-allowed',
      },
      _readOnly: {
        cursor: 'default',
      },
    },
    control: {
      position: 'relative',
      borderRadius: '4',
      backgroundColor: 'background/primary',
      border: '1px solid',
      borderColor: 'border/regular',
      boxShadow: 'inset/field',
      focusVisibleRing: 'outside',
      '& > svg': {
        position: 'absolute',
        left: '-1px',
        visibility: 'hidden',
      },
      _checked: {
        backgroundColor: 'input/checkbox/selection',
        borderColor: 'input/checkbox/selection !important',
        boxShadow: 'none',
        '& > svg': {
          top: 0,
          color: 'icon/on-color',
          visibility: 'visible',
        },
        _disabled: {
          backgroundColor: 'input/checkbox/selection-disabled',
          borderColor: 'input/checkbox/selection-disabled !important',
        },
        _readOnly: {
          '& > svg': {
            color: 'icon/on-disabled',
          },
        },
      },
      _hover: {
        borderColor: 'border/hover',
      },
      _indeterminate: {
        backgroundColor: 'input/checkbox/selection',
        borderColor: 'input/checkbox/selection !important',
        boxShadow: 'none',
        '& > svg': {
          top: '-1px',
          color: 'icon/on-color',
          visibility: 'visible',
        },
        _disabled: {
          backgroundColor: 'input/checkbox/selection-disabled',
          borderColor: 'input/checkbox/selection-disabled !important',
        },
        _readOnly: {
          '& > svg': {
            color: 'icon/on-disabled',
          },
        },
      },
      _disabled: {
        backgroundColor: 'background/disabled',
        borderColor: 'border/disabled',
        boxShadow: 'none',
      },
      _readOnly: {
        backgroundColor: 'background/disabled',
        borderColor: 'border/regular !important',
        boxShadow: 'none',
      },
    },
    label: {
      userSelect: 'none',
      color: 'input/text/inputValue',
      _disabled: {
        color: 'text/disabled',
      },
    },
  },
  variants: {
    size: {
      md: {
        control: {
          width: '20',
          height: '20',
          '& > svg': {
            width: '20',
            height: '20',
          },
        },
        label: {
          textStyle: 'body/md/regular',
        },
      },
      lg: {
        control: {
          width: '24',
          height: '24',
          '& > svg': {
            width: '24',
            height: '24',
          },
        },
        label: {
          textStyle: 'body/lg/regular',
        },
      },
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default checkboxSlotRecipe;
